var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-secundaria area-cadu",class:_vm.disabled ? 'disabled-text': '',style:({ color: _vm.colorText })},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_c('textarea',{ref:"textarea",staticClass:"textarea-cadu",class:{
              'cadu-textarea--disabled': _vm.disabled,
              'cadu_textarea--error': _vm.hasError,
              'cadu_textarea--success': _vm.hasSuccess
            },attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder,"spellcheck":"false","minlength":_vm.min,"maxlength":_vm.max},domProps:{"value":_vm.value},on:{"input":_vm.emitValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }